export default __webpack_public_path__ + "static/media/AAB22280-CB6A-4FC3-9E81-B691A88A2AC5.e6b48e2a.jpeg";